var React = require('react');

var Button = require('../button');

var css = require('./module.scss');

var Items = React.createClass({

    onPageChange: function(page) {
        if (page < this.props.min || page > this.props.max) {
            return;
        }

        this.props.onPageChange(page);
    },

    pages: function() {
        var i;
        var max;
        var len = this.props.len || 3;
        var min = this.props.page - Math.floor(len / 2);
        var arr = [];
        if (min + len - 1 > this.props.max) {
            min = this.props.max - len + 1;
        }

        if (min < this.props.min) {
            min = this.props.min;
        }

        for (i = min, max = min + len; i < max; i++) {
            if (i > this.props.max) {
                break;
            }

            arr.push(i);
        }

        return arr;
    },

    render: function() {
        var _this = this;
        var hasPrev = this.props.page <= this.props.min;
        var hasNext = this.props.page >= this.props.max;
        var cls = ['fp-items'];
        if (this.props.btnSize) {
            cls.push('fp-items-' + this.props.btnSize);
        }
        return (
            <ul className={cls.join(' ')}>
                {/* <li>
                    <Button
                        className='fp-page-control'
                        style="default"
                        text="第一页"
                        size={this.props.btnSize || ''}
                        disabled={this.props.page == this.props.min}
                        onClick={this.onPageChange.bind(this, this.props.min)}
                    />
                </li> */}
                <li>
                    <Button
                        className='fp-page-control fp-prev'
                        style="default"
                        size={this.props.btnSize || ''}
                        disabled={this.props.page <= this.props.min}
                        onClick={this.onPageChange.bind(this, this.props.page - 1)}
                    />
                </li>
                {
                    this.pages().map(function(page) {
                        var cls = [];
                        if (page == _this.props.page) {
                            cls.push('fp-page-active');
                        }

                        return (
                            <li className={cls.join(' ')}>
                                <Button
                                    className='fp-item'
                                    style="default"
                                    text={page}
                                    size={this.props.btnSize || ''}
                                    onClick={_this.onPageChange.bind(_this, page)}
                                />
                            </li>
                        );
                    }.bind(this))
                }
                <li>
                    <Button
                        className='fp-page-control fp-next'
                        style="default"
                        size={this.props.btnSize || ''}
                        disabled={this.props.page >= this.props.max}
                        onClick={this.onPageChange.bind(this, +this.props.page + 1)}
                    />
                </li>
                {/* <li>
                    <Button
                        className='fp-page-control'
                        style="default"
                        text="最后一页"
                        size={this.props.btnSize || ''}
                        disabled={this.props.page == this.props.max}
                        onClick={this.onPageChange.bind(this, this.props.max)}
                    />
                </li> */}
            </ul>
        );
    }

});

module.exports = Items;



// WEBPACK FOOTER //
// ./component/pagination/items.js